<template>
  <div class="container">
    <HomeHeader />
    <div class="content">
      <van-card
        v-for="(item, index) in termsList"
        :key="index"
        class="content-card"
        :title="item.title"
        :thumb="splitFn(item.images)"
        @click="onClickCard(item.id, item)"
      >
        <template #tags>
          <div
            class="content-type o"
            v-if="
              curtime >= item.votestarttime * 1000 &&
              item.voteendtime * 1000 >= curtime
            "
          >
            <span>正在进行</span>
          </div>
          <div
            class="content-type r"
            v-else-if="item.voteendtime * 1000 < curtime"
          >
            <span>已结束</span>
          </div>
          <div class="content-type g" v-else>
            <span>未开始</span>
          </div>
        </template>
      </van-card>
    </div>
    <div class="bottom-btn-pos" v-show="active == 'numlist'"><VoteBtn /></div>
  </div>
</template>

<script>
import { Card, Button, Toast } from "vant";
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import VoteBtn from "@/components/VoteBtn.vue";
import HomeHeader from "@/components/HomeHeader.vue";
import useShare from "@/plugins/useShare.js";

import { useRouter, useRoute } from "vue-router";

export default {
  name: "ActivityView",
  components: {
    VoteBtn,
    HomeHeader,
    [Button.name]: Button,
    [Card.name]: Card,
    [Toast.name]: Toast,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    onMounted(() => {
      useShare();
    });

    // const id = ref(1);
    if (route.query.id) store.state.termId = Number(route.query.id);
    console.log("2有没有id", store.state.termId);
    // if (route.query.id) id.value = Number(route.query.id);
    const id = store.state.termId;

    let params = {
      term_id: id,
    };
    store.dispatch("getAppEnv", { params });
    store.dispatch("getTerms");

    const splitFn = (images) => {
      if (images.length > 0) {
        images = images.split(",");
      }
      console.log(images);
      return images[0];
    };

    const onClickCard = (id, item) => {
      console.log("点击", item);
      store.state.termId = item.id;
      if (store.state.termsCurtime < item.votestarttime * 1000) {
        Toast("该档期活动未开始");
      } else if (
        store.state.curtime >= item.votestarttime * 1000 &&
        item.voteendtime * 1000 >= store.state.curtime
      ) {
        router.push("/?id=" + id);
        // router.push("/");
      } else {
        router.push("/activity_view/?id=" + id);
        // router.push("/activity_view/");
      }
    };

    return {
      splitFn,
      onClickCard,
      termsList: computed(() => store.state.termsList),
      curtime: computed(() => store.state.termsCurtime),
    };
  },
  data() {
    return {
      active: "awardPage",
      tabsArray: [
        {
          describe: "编号排序",
          type: "awardPage",
        },
        {
          describe: "排行榜",
          type: "ranklist",
        },
        {
          describe: "投票规则",
          type: "rule",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: $light-gray;
}
.image {
  width: 100%;
  height: auto;
}
.content {
  position: relative;
  margin: 12px 0px;
}
.content-card {
  text-align: left;
  font-size: 4vw;
}
.van-card__title {
  line-height: var(--van-card-title-line-height);
}
.content-type {
  text-align: right;
  position: absolute;
  right: 0;
  top: 67px;
  width: 70px;
  height: 20px;
  border-radius: 10px;
  text-align: center;
  line-height: 17px;
  span {
    color: #fff;
    font-size: 3.2vw;
  }
}
.g {
  background: #27b148;
}
.o {
  background: #f78a05;
}
.r {
  background: #ff2525;
}
.bottom-btn-pos {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: white;
  z-index: 100;
  padding-bottom: env(safe-area-inset-bottom);
}
</style>
